import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs';

import OrderAdjustedPositionsContainer from '../../containers/order-adjusted-positions-container';
import OrderDetailedPositionsContainer from '../../containers/order-detailed-positions-container';
import AppPageMain from '../../modules/app-page/app-page--main';
import PageHeader from '../../modules/page-header';

const OrderRealizationsPage: React.FC = () => {
  const location = useLocation();
  const params = qs.parse(location.search);
  const { id, itemId } = useParams<{ id: string; itemId: string }>();

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/orders', title: 'Реестр' },
                {
                  link: `/orders/${id}`,
                  title: `Поставка ${id}`,
                },
                {
                  link: `/orders/${id}/items/${itemId}/realizations`,
                  title: 'Реализация',
                },
              ]}
              iconType="order"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            {params['?type'] === 'attached' ? (
              <OrderAdjustedPositionsContainer />
            ) : (
              <OrderDetailedPositionsContainer />
            )}
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default OrderRealizationsPage;
